<template>
  <Popup class="bio-popup" :darkCloseButton="true" @close="close">
    <img class="hand" :src="$assets.image['bio_hand.png']" alt="" />

    <div class="main-content">
      <div class="image">
        <img
          class="photo"
          :src="bio.bio_image || $assets.image.default['bio_default_sq.svg']"
          :alt="`Photo of ${bio.bio_name}`"
        />
      </div>

      <div class="info-container">
        <p class="name">{{ bio.bio_name }}</p>
        <p class="information">{{ bio.bio_information }}</p>
      </div>
    </div>

    <a v-if="this.bio.bio_linkedin" :href="linkedinAddress" target="_blank" rel="noopener noreferrer" class="linkedin">
      <img class="icon" :src="$assets.svg['linkedin_icon']" alt="" />
      {{ bio.bio_linkedin }}
    </a>
  </Popup>
</template>

<script>
import Popup from '@/components/events/Popup.vue';

export default {
  props: {
    bio: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    linkedinAddress() {
      if (this.bio.bio_linkedin.startsWith('https')) {
        return this.bio.bio_linkedin;
      }
      return `https://${this.bio.bio_linkedin}`;
    },
  },

  components: {
    Popup,
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.bio-popup {
  --image-width: 200px;

  font-family: Helvetica;
  font-size: 1em;
}

.bio-popup :deep(.popup-window) {
  width: 80%;
  max-width: 996px;
  height: unset;

  background-color: #defaff;
  border-radius: 2em;
  color: #333333;

  overflow: hidden;
}

.bio-popup :deep(.popup-content) {
  padding: 20px;
  padding-bottom: 80px;
}

.hand {
  position: absolute;
  bottom: 0;
  right: 0;

  height: 90px;
}

.main-content {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.image {
  height: var(--image-width);
  width: var(--image-width);

  border-radius: 50%;
  background: linear-gradient(#28cede, #56b4ff);

  overflow: hidden;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.image > .photo {
  height: 90%;
  width: 90%;
  border-radius: 50%;

  object-fit: cover;
}

.info-container {
  width: calc(100% - var(--image-width) - 100px);
  min-width: var(--image-width);
}

.name {
  font-size: 1.3em;
}

.information {
  font-size: 1em;
}

.linkedin {
  width: var(--image-width);
  margin-top: 1em;

  font-size: 1em;
  color: #053f89;
  text-decoration: none;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.linkedin > .icon {
  height: 2em;
  width: 2em;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .bio-popup :deep(.popup-content) {
    width: calc(100% - 40px);
    padding: 20px;
  }

  .hand {
    height: 60px;
  }

  .info-container {
    padding: 0 10px;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .bio-popup {
    --image-width: 280px;
  }

  .bio-popup :deep(.popup-content) {
    width: calc(100% - 112px);
    padding: 56px;
  }

  .info-container {
    padding: 0 49px;
  }
}
</style>
